import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  CustomSoftIcon,
  SoftwareProIcon,
  SoftwareMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby"; // Import Gatsby's Link component
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        Improve your{" "}
        <Link to="/android-app-development">Android app development</Link>{" "}
        experience with TekRevol, utilizing the world\'s most extensively used
        medium with native apps. Our dynamic tech stack of Java or Kotlin
        respires life into your app impressions with exactness and origination.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description:
      "Uplift your iOS understanding with TekRevol's iPhone App Development, providing sophisticated, spotlessly practical native apps. We methodically study every feature, assuring your app effortlessly aligns with Apple's layout viewpoints and ideologies.",
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        Dive into the rewarding gaming industry with TekRevol's{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          mobile game development,
        </Link>{" "}
        delivering extremely engaging and monetization-ready games for your
        business venture. Gifted in numerous categories such as shooting,
        arcade, RPG, and strategy, we can develop any game concept you imagine
        to life.
      </>
    ),
  },
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description:
      "Exclusive software solutions created to meet your explicit business requirements, warranting optimal functionality and success. TekRevol empowers your software ventures with wide-ranging knowledge and plentiful resources, boosting innovation and productivity.",
  },
  {
    icon: SoftwareProIcon,
    title: "Software Product Development",
    description:
      "State-of-the-art and scalable software product development, driving market success through ingenuity and progressive technology. TekRevol focuses on strong SaaS, Mobile, and desktop software products, offering supreme user experiences in New York and beyond.",
  },
  {
    icon: SoftwareMainIcon,
    title: "Software Support and Maintenance",
    description:
      "Consistent support and maintenance services, reassuring impeccable operations and durability of your software products. We promise immaculate functionality and robustness through nonstop performance monitoring, enhancement, feature developments, and issue addressing, all in New York.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              TekRevol’s Custom App and Software Development Services in New
              York
            </h2>
            <p className="impro_para">
              Board on a revolutionary journey with TekRevol’s custom software
              and application solutions, designed to improve your digital
              reality. Transform your business by leveraging cutting-edge
              technology and innovative approaches, ensuring unparalleled
              success and optimal market performance. We are your complete
              development partner, devoted to uplifting your business to new
              heights.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
